
const selectProjectList = (state) => state.getIn(['workspaceProjects', 'projects']);

const selectedProject = (state) => state.getIn(['workspaceProjects', 'selectedProject']);

const selectedProjectId = (state) => state.getIn(['workspaceProjects', 'selectedProject', 'id']);

const getIngestionList = (state) => state.getIn(['workspaceProjects', 'ingestionList']);

const getActivityLiveList = (state) => state.getIn(['workspaceProjects', 'activityLiveList']);

const getElementPublishedList = (state) => state.getIn(['workspaceProjects', 'elementPublishedList']);

const getMarketDerivativeList = (state) => state.getIn(['workspaceProjects', 'marketDerivativesList']);

const getLanguagesList = (state) => state.getIn(['workspaceProjects', 'languagesList']);

const getSelectedLanguage = (state) => state.getIn(['workspaceProjects', 'selectedLanguage']);

export {
  selectProjectList,
  selectedProject,
  selectedProjectId,
  getIngestionList,
  getActivityLiveList,
  getElementPublishedList,
  getMarketDerivativeList,
  getLanguagesList,
  getSelectedLanguage,
};
